import usePrivateAxios from "@/common/api/usePrivateAxios"
import { ErrorResponse } from "@/common/types/errorResponse";
import { useMutation } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { NotificationsConfigurationsValidationSchema } from "../schemas/update.schema";

interface UseNotificationsConfigurationsRegisterNotificationsProps {
  onSuccess?: (response: AxiosResponse) => void;
  onError?: (error: ErrorResponse) => void;
}

export const useNotificationsConfigurationsRegisterNotifications = ({ onSuccess, onError }: UseNotificationsConfigurationsRegisterNotificationsProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationFn: (form: NotificationsConfigurationsValidationSchema) => {
      const payload = {
        notification_configurations: Object.keys(form).map((notification_klass) => {
          return {
            notification_klass,
            provider_klasses: form[notification_klass].value === 'all' ? [] : [form[notification_klass].value],
          }
        })
      }

      return privateAxios.post(`/notification_configurations/register_configurations`, payload);
    },
    onSuccess,
    onError,
  });
}
